import React from 'react';
import { Disclosure, DisclosureButton, DisclosurePanel, Transition } from '@headlessui/react';
import { ChevronRightIcon } from '@heroicons/react/20/solid';
import { classNames } from 'utils/styleUtils';
import SchemaNode from './SchemaNode';
import SnowflakeIcon from 'components/SnowflakeIcon';

interface DatabaseNodeProps {
  name: string;
  data: any;
}

export default function DatabaseNode(props: DatabaseNodeProps): JSX.Element {
  const { name, data } = props;
  return (
    <Disclosure defaultOpen={true}>
      {({ open }) => (
        <>
          <div className="w-3/4 relative flex py-1 border border-gray-300 bg-gray-50 rounded-md text-gray-700 cursor-default px-2">
            <div className="min-w-[20px] w-5 mr-1">
              <SnowflakeIcon objectType="database" highlighted={false} />
            </div>
            <div className="text-sm truncate mr-2">{name.replace(/['"{}]/g, '')}</div>
            <DisclosureButton className="absolute right-1 w-5 cursor-pointer">
              <ChevronRightIcon
                className={classNames(
                  open ? 'transform rotate-90' : '',
                  'w-5 h-5 ml-auto text-gray-700 transition duration-150 ease-in-out',
                )}
              />
            </DisclosureButton>
          </div>

          <Transition
            show={open}
            enter="transition duration-100 ease-out"
            enterFrom="transform scale-95 opacity-0"
            enterTo="transform scale-100 opacity-100"
            leave="transition duration-75 ease-out"
            leaveFrom="transform scale-100 opacity-100"
            leaveTo="transform scale-95 opacity-0"
          >
            <DisclosurePanel className="w-3/4 px-4 space-y-1">
              {data.schemas !== undefined && Object.keys(data.schemas).length > 0 ? (
                Object.entries(data.schemas).map(([schemaName, schemaData]: [string, any]) => (
                  <SchemaNode key={schemaName} name={schemaName} data={schemaData} />
                ))
              ) : (
                <div className="mb-2 text-sm text-gray-500">No objects found</div>
              )}
            </DisclosurePanel>
          </Transition>
        </>
      )}
    </Disclosure>
  );
}
